import React from 'react';
import type { IconProps } from './types';

// Padlock glyph. `locked` toggles the shackle between closed and open.
const LockIcon: React.FC<IconProps & { locked?: boolean }> = ({
  size = 13,
  color = 'currentColor',
  locked = true,
  ...props
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <rect x="5" y="10.5" width="14" height="9.5" rx="2" fill={color} />
    {locked ? (
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke={color} strokeWidth={2} fill="none" />
    ) : (
      <path d="M8 10.5V8a4 4 0 0 1 7.7-1.5" stroke={color} strokeWidth={2} fill="none" />
    )}
  </svg>
);

export default LockIcon;
